import { QuestionBase, QuestionOptions } from './base.question.class'

interface RadioQuestionOptions extends QuestionOptions<string> {
  if?: string | boolean
}

export class RadioQuestion extends QuestionBase<string> {
  controlType = 'radio-button'
  if: string | boolean

  get showIfQuestions() {
    return this.ifQuestions.length > 0 && this.valid && this.value === this.if
  }
  constructor(options: RadioQuestionOptions = {}) {
    super(options)
    if (this.isCustom && options['options']) {
      this.options =
        options['options']['radio-opts'].map((value) => {
          return {
            value,
            viewValue: value,
          }
        }) || []
    } else {
      this.options = options['options'] || []
    }

    this.ifQuestions = options.ifQuestions
    this.if = options.if
  }
}
